import { Injectable } from '@angular/core'
import { HttpParams } from '@angular/common/http'
import { BehaviorSubject } from 'rxjs'
import { CommonService } from '../../shared/services/common.service'
export const headerOptions = { responseType: 'text' as 'json' }

@Injectable({
  providedIn: 'root',
})
export class OrderTrackingService {
  emitTileStatus = new BehaviorSubject<any>('All Orders')

  constructor(public commonService: CommonService) {}

  getOrderTrackingDetails(orderId, fromDate, toDate) {
    const urlParams = ['users', 'current', 'orders']
    let lastPart = `${orderId}?fields=DEFAULT`
    lastPart += `&fromDate=${fromDate}&toDate=${toDate}`
    urlParams.push(lastPart)
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.getData(apiUrl)
  }

  getOrders(
    currentUserUid,
    serialNumber,
    statusFilter,
    dateRange,
    fromDate,
    toDate,
    pageNo = 1,
    pageSize = 50,
    sortBy
  ) {
    const urlParam = ['users', currentUserUid]
    let lastPart = 'vsorders?fields=DEFAULT'
    if (serialNumber && serialNumber.trim().length) {
      lastPart += `&searchTerm=${serialNumber}`
    }
    if (statusFilter) {
      lastPart += `&status=${statusFilter}`
    }
    // if (dateRange) {
    lastPart += `&fromDate=${fromDate}&toDate=${toDate}`
    // }
    lastPart += `&currentPage=${pageNo}&pageSize=${pageSize}`
    if (sortBy) {
      lastPart += `&sortBy=${sortBy}`
    }
    urlParam.push(lastPart)
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl)
  }

  getRefreshOrders(
    currentUserUid,
    serialNumber,
    statusFilter,
    dateRange,
    fromDate,
    toDate,
    pageNo = 1,
    pageSize = 50,
    sortBy,
    isRefreshedFlag
  ) {
    const urlParam = ['users', currentUserUid]
    let lastPart = 'vsorders?fields=DEFAULT'
    if (serialNumber && serialNumber.trim().length) {
      lastPart += `&searchTerm=${serialNumber}`
    }
    if (statusFilter) {
      lastPart += `&status=${statusFilter}`
    }
    // if (dateRange) {
    lastPart += `&fromDate=${fromDate}&toDate=${toDate}`
    // }
    lastPart += `&currentPage=${pageNo}&pageSize=${pageSize}`
    if (sortBy) {
      lastPart += `&sortBy=${sortBy}`
    }
    lastPart += `&isRefreshedFlag=${isRefreshedFlag}`
    urlParam.push(lastPart)
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl)
  }
  getDetailsinXLSFormat(
    currentUserUid,
    searchTerm,
    statusFilter,
    dateRange,
    fromDate,
    toDate,
    pageNo = 1,
    totalOrders_excel
  ) {
    const urlParam = ['users', currentUserUid, 'orders', 'export']
    const apiUrl = this.commonService.constructUrl(urlParam)

    let params = new HttpParams()
    if (searchTerm.trim().length > 0) {
      params = params.append('searchTerm', searchTerm)
    }
    if (statusFilter) {
      params = params.append(
        'status',
        statusFilter === 'Shipped %26 Invoiced'
          ? 'Shipped & Invoiced'
          : statusFilter
      )
    }
    // if (dateRange) {
    params = params.append('fromDate', fromDate)
    params = params.append('toDate', toDate)
    // }
    params = params.append('pageSize', totalOrders_excel)
    params = params.append('currentPage', pageNo.toString())

    return this.commonService.getData_Excel(apiUrl, params)
  }

  repeatOrder(orderNumber, cartId) {
    const urlParam = ['users', 'current', 'carts', cartId, 'reOrder']
    const apiUrl = this.commonService.constructUrl(urlParam)
    let params = new HttpParams()
    params = params.append('code', orderNumber)
    params = params.append('fields', 'FULL')
    params = params.append('rfqFlag', 'true')
    return this.commonService.postData(apiUrl, params)
  }

  getInquiryTypes() {
    const urlParam = ['users', 'current', 'inquirydetails']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl, headerOptions)
  }

  submitInquiryToCSR(
    inquiryDropdownValue,
    description,
    orderNumber,
    customerPO,
    poDate
  ) {
    const urlParam = ['users', 'current', 'inquirydetails']
    const apiUrl = this.commonService.constructUrl(urlParam)
    const apiParams = {
      inquiryCode: orderNumber,
      inquiryDescription: description,
      inquiryTypeCode: inquiryDropdownValue,
      isRfqQuote: false,
      customerPO: customerPO,
      purchaseOrderDate: poDate,
      orderId: orderNumber,
    }
    return this.commonService.postData(apiUrl, apiParams, headerOptions)
  }

  getAllDocuments(orderNumber) {
    const urlParam = ['users', 'current', 'orders', 'fetchAttachmentList']
    const apiUrl = this.commonService.constructUrl(urlParam)
    const apiParams = {
      orderNo: orderNumber,
    }
    return this.commonService.getData(apiUrl, apiParams)
  }

  downloadDocument(docNumber, docType, fileName, fileType) {
    const urlParam = ['users', 'current', 'orders', 'downloadAttachment']
    const apiUrl = this.commonService.constructUrl(urlParam)
    let params = new HttpParams()
    params = params.append('docNumber', docNumber)
    params = params.append('docType', docType)
    params = params.append('fileName', fileName)
    params = params.append('fileType', fileType)
    if (fileType == 'pdf') {
      return this.commonService.getData_PDF(apiUrl, params)
    } else if (fileType == 'doc' || fileType == 'docx') {
      return this.commonService.getData_Doc(apiUrl, params)
    } else if (fileType == 'jpg' || fileType == 'JPG') {
      return this.commonService.getData_JPG(apiUrl, params)
    } else if (fileType == 'png' || fileType == 'PNG') {
      return this.commonService.getData_PNG(apiUrl, params)
    } else if (fileType == 'xls' || fileType == 'xlsx') {
      return this.commonService.getData_Excel(apiUrl, params)
    }
  }

  downloadOrderDetails(obj, orderNumber) {
    const urlParam = [
      'users',
      'current',
      'orders',
      orderNumber,
      'downloadOrderDetailsPDF',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData_PDF_Detail(apiUrl, obj)
  }

  getConfigMonth() {
    const urlParam = ['order-listing', 'getConfigurableMonth']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl)
  }
}
